import styled from 'styled-components'

export const Container = styled.div`
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`

export const Label = styled.span`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
`

export const Text = styled.p`
  font-size: 14px;
  margin-bottom: 1rem;
`